"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.6773 38.525C17.5628 38.525 10.7628 34.5479 4.45239 26.6917L3.74609 25.8103L4.35861 24.8625C4.66694 24.3875 12.0503 13.1958 23.5815 12.5417C30.9857 12.0854 38.3732 16.2187 45.3524 24.7229L46.1149 25.6478L45.4149 26.6229C45.0774 27.0979 36.9898 38.1937 25.2065 38.5166C25.0273 38.5228 24.844 38.525 24.6773 38.525ZM7.64192 25.6478C13.2315 32.2749 19.1232 35.5792 25.1003 35.3937C33.4648 35.1729 39.9899 28.2958 42.1274 25.7417C36.0857 18.7125 29.9232 15.2978 23.7753 15.6603C15.6128 16.1103 9.57525 23.1062 7.64192 25.6478Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.6795 33.1604C23.1347 33.1604 21.6247 32.7023 20.3402 31.8441C19.0558 30.9859 18.0547 29.7661 17.4636 28.3389C16.8724 26.9118 16.7177 25.3413 17.0191 23.8263C17.3205 22.3112 18.0644 20.9195 19.1567 19.8272C20.249 18.7349 21.6407 17.9911 23.1557 17.6897C24.6708 17.3883 26.2412 17.5429 27.6684 18.1341C29.0956 18.7253 30.3154 19.7263 31.1736 21.0108C32.0318 22.2952 32.4899 23.8052 32.4899 25.35C32.4871 27.4206 31.6633 29.4056 30.1992 30.8697C28.7351 32.3339 26.7501 33.1577 24.6795 33.1604ZM24.6795 20.6604C23.7527 20.6604 22.8467 20.9353 22.0762 21.4502C21.3056 21.9651 20.7051 22.697 20.3505 23.5533C19.9959 24.4095 19.9033 25.3517 20.0842 26.2607C20.2652 27.1696 20.7116 28.0046 21.3671 28.6597C22.0226 29.3149 22.8577 29.7609 23.7667 29.9415C24.6757 30.122 25.6179 30.029 26.474 29.6741C27.3301 29.3191 28.0617 28.7182 28.5762 27.9474C29.0908 27.1766 29.3653 26.2705 29.3649 25.3437C29.3616 24.1029 28.8666 22.9139 27.9884 22.0373C27.1102 21.1607 25.9203 20.6678 24.6795 20.6667V20.6604Z",
    fill: fill
  }));
};

exports["default"] = _default;